export default {
    ABOUT: "О приложении",
    CHANGE_PASSWORD: "Изменить пароль",
    TITLE_PASSWORD: "Изменение пароля",
    LOGOUT_ERROR: "Не удалось выполнить выход",
    EXIT: "Выйти"
};
